import React, { useState } from 'react';
import LogoBCA from '../../../assets/logo/bca.png';
import LogoMandiri from '../../../assets/logo/mandiri.png';
import LogoBRI from '../../../assets/logo/bri.png';

const Transfer = ({
  listTransfer = [
    {
      nameBank: 'BCA',
      logoBank: LogoBCA,
    },
    {
      nameBank: 'Mandiri',
      logoBank: LogoMandiri,
    },
    {
      nameBank: 'BRI',
      logoBank: LogoBRI,
    },
  ],
  handleHowToTransfer,
}) => {
  // const [showHowTransfer, setHowTransfer] = useState(null);

  return (
    <div className="flex flex-col my-4">
      <p className="my-2 font-semibold">Transfer</p>

      {listTransfer.map((listTransfers, index) => (
        <button
          className="pl-6 pr-5 py-4 border border-transparent hover:border-orange-500 flex items-center rounded"
          key={index}
          onClick={handleHowToTransfer}
        >
          <img
            src={listTransfers.logoBank}
            className="h-auto w-12 mr-4 "
            alt=""
          />
          <p>{listTransfers.nameBank}</p>
          <svg
            className="w-6 h-6 ml-auto my-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </button>
      ))}
    </div>
  );
};

export default Transfer;
